import React, { useEffect, useState } from 'react';

import { APIROOT } from '../../Helpers/configs';

import { Grid, Typography } from '@mui/material';

import { convertDate } from '../../Helpers/helpers';

const InstallReportCustomerInfo = (props) => {
  const jobcardInfo = props.jobcardInfo;
  const [timeIn, setTimeIn] = useState('');
  const [customerInfo, setCustomerInfo] = useState({
    ...props.customerData,
    time_in: timeIn,
    time_out: convertDate(
      new Date() === undefined
        ? 'Thu Jan 19 2023 15:02:56 GMT+0200 (South Africa Standard Time)'
        : new Date(),
      0,
      17
    ),
  });

  useEffect(() => {
    checkClock(props.customerData.id).then((data) => {
      setTimeIn(convertDate(data.data.value.first_start_ts));
      setCustomerInfo({
        ...props.customerData,
        time_in: convertDate(data.data.value.first_start_ts, 0, 17),
        time_out: convertDate(
          new Date() === undefined
            ? 'Thu Jan 19 2023 15:02:56 GMT+0200 (South Africa Standard Time)'
            : new Date(),
          0,
          17
        ),
        date_today: convertDate(
          new Date() === undefined
            ? 'Thu Jan 19 2023 15:02:56 GMT+0200 (South Africa Standard Time)'
            : new Date(),
          0,
          10
        ),
      });
    });
  }, [jobcardInfo, props]);
  const infoBlock = (
    key,
    title,
    info,
    titleGridLarge,
    titleGridSmall,
    infoGridLarge,
    infoGridSmall
  ) => {
    return (
      <>
        <Grid
          item
          // border={'grey solid 1px'}
          xs={titleGridSmall}
          md={titleGridLarge}
          sx={{
            minHeight: '40px',
            border: title === 'NotDefined' ? 'none' : 'grey solid 1px',
            textAlign: 'left',
            borderRight: 'none',
            borderBottom:
              title === 'Branch Code:' || title === 'Technician:'
                ? 'grey solid 1px'
                : 'none',
          }}
        >
          <Typography fontWeight='700' variant='subtitle1'>
            {title}
          </Typography>
        </Grid>
        <Grid
          item
          border={'grey solid 1px'}
          xs={infoGridSmall}
          md={infoGridLarge}
          style={{
            textAlign: 'left',
            borderLeft: 'none',
            borderBottom:
              title === 'Branch Code:' || title === 'Technician:'
                ? 'grey solid 1px'
                : 'none',
          }}
        >
          <Typography variant='subtitle1'>
            {key === 'date_logged' ? convertDate(info, 0, 17) : info}
          </Typography>
        </Grid>
      </>
    );
  };

  //Define Items and the order of the blocks
  //[ Title, PC Grid Size for Title, Mobile Grid Size for Title, PC Grid Size for Info, Build order Mobile Grid Size for Info, Build order ]
  const defineBlocks = (dataItem) => {
    switch (dataItem) {
      case 'customer_name':
        return ['Store Name:', 2, 4, 4, 8, '1'];
      case 'date_today':
        return ['Date:', 1, 4, 5, 8, '2'];
      case 'customer_address':
        return ['Address:', 2, 4, 4, 8, '3'];
      case 'time_in':
        return ['Time In:', 1, 2, 2, 4, '4'];
      case 'time_out':
        return ['Time Out:', 1, 2, 2, 4, '5'];
      case 'customer_contact_name':
        return ['Contact Person:', 2, 4, 4, 8, '6'];
      case 'capex_number':
        return ['CAPEX Order:', 2, 4, 4, 8, '7'];
      case 'customer_contact_number':
        return ['Contact Number:', 2, 4, 4, 8, '8'];
      case 'dn_number':
        return ['Delivery Note:', 2, 4, 4, 8, '9'];
      case 'customer_branchcode':
        return ['Branch Code:', 2, 4, 4, 8, '10'];
      case 'tech_assigned_name':
        return ['Technician:', 2, 4, 4, 8, '10'];
      default:
        return ['NotDefined'];
    }
  };

  const createBlocks = (obj) => {
    //Prepare build blocks from object
    let returnBlocks = [];
    Object.keys(obj).forEach((key) => {
      let blockData = defineBlocks(key);
      if (blockData[0] !== 'NotDefined') {
        returnBlocks = [
          ...returnBlocks,
          {
            key: key,
            id: blockData[5],
            title: blockData[0],
            info: obj[key],
            titleGridLarge: blockData[1],
            titleGridSmall: blockData[2],
            infoGridLarge: blockData[3],
            infoGridSmall: blockData[4],
          },
        ];
      }
    });
    //Sort and build grid blocks
    return returnBlocks
      .sort((a, b) => a.id - b.id)
      .map((item) =>
        infoBlock(
          item.key,
          item.title,
          item.info,
          item.titleGridLarge,
          item.titleGridSmall,
          item.infoGridLarge,
          item.infoGridSmall
        )
      );
  };

  return (
    <>
      {createBlocks(customerInfo)}
      <Grid
        item
        xs={4}
        md={2}
        sx={{
          textAlign: 'left',
          borderRight: 'none',
        }}
      ></Grid>
    </>
  );
};

export default InstallReportCustomerInfo;

async function checkClock(ticketId) {
  let JWT = localStorage.getItem('JWT_Key');
  let headers = {
    'content-type': 'application/JSON',
  };
  if (JWT) {
    headers['x-api-key'] = JWT;
  }
  let body = {
    fetch: 'ticket_hours_install',
    fetchid: ticketId,
  };
  const request = new Request(`${APIROOT}/api/actions`, {
    method: 'post',
    headers,
    body: JSON.stringify(body),
  });
  const response = await fetch(request);

  const data = response.json();
  return data;
}
